// eslint-disable-next-line import/no-anonymous-default-export
export default {
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  search: 'Search',
  filter: 'Filter',
  export: 'Export',
  import: 'Import',
  loading: 'Loading...',
  saving: 'Saving...',
  noData: 'No data found',
  actions: 'Actions',
  status: 'Status',
  active: 'Active',
  passive: 'Passive',
  inactive: 'Inactive',
  yes: 'Yes',
  no: 'No',
  all: 'All',
  update: 'Update',
  view: 'View',
  details: 'Details',
  description: 'Description',
  notes: 'Notes',
  date: 'Date',
  amount: 'Amount',
  currency: 'Currency',
  name: 'Name',
  email: 'E-mail',
  phone: 'Phone',
  address: 'Address',
  website: 'Website',
  type: 'Type',
  price: 'Price',
  purchasePrice: 'Purchase Price',
  salePrice: 'Sale Price',
  profit: 'Profit',
  total: 'Total',
  monthly: 'Monthly',
  yearly: 'Yearly',
  oneTime: 'One Time',
  startDate: 'Start Date',
  endDate: 'End Date',
  registrationDate: 'Registration Date',
  expiryDate: 'Expiry Date',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  unknownError: 'Unknown error',
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
  confirm: 'Confirm',
  confirmDelete: 'Are you sure you want to delete?',
  searchPlaceholder: 'Search...',
  noResults: 'No results found',
  required: 'Required',
  optional: 'Optional',
  select: 'Select',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  showing: 'Showing',
  of: 'of',
  page: 'Page',
  perPage: 'per page',
  previous: 'Previous',
  next: 'Next',
  first: 'First',
  last: 'Last',
  locale: 'en-US',
  typeDomain: 'Domain',
  typeHosting: 'Hosting',
  typeSsl: 'SSL',
  typeEmail: 'E-mail',
  typeReklam: 'Advertisement',
  typeDanismanlik: 'Consulting',
  typeOther: 'Other',
  connectorInfo: 'Payment connector is established through the company.',
  newRecurringPayment: 'New Recurring Payment',
  editRecurringPayment: 'Edit Recurring Payment',
  company: 'Company',
  selectCompany: 'Select Company',
  packageType: 'Package Type',
  selectHostingPackage: 'Select Hosting Package',
  manualEntry: 'Manual entry',
  noHostingPrice: 'Price not defined',
  packageName: 'Package Name',
  examplePackage: 'Ex: Domain Package',
  getDomainPrice: 'Price',
  selectDomain: 'Select Domain',
  selectDomainOptional: 'Select Domain (Optional)',
  getDatesFromWhois: 'WHOIS',
  whois: 'WHOIS',
  noDomainFound: 'No domain found',
  paymentProbability: 'Payment Probability',
  paymentProbabilityHint: 'Between 0-100',
  nextPayment: 'Next Payment',
  additionalNotes: 'Additional notes...',
  addPayment: 'Add Payment',
  clear: 'Clear',
  groupByCompany: 'Group by Company',
  payments: 'payments',
  totalPurchase: 'Total Purchase',
  totalSale: 'Total Sale',
  totalProfitLoss: 'Total Profit/Loss',
  purchase: 'Purchase',
  sale: 'Sale',
  daysLeft: 'days left',
  daysPast: 'days past',
  na: 'N/A',
  extendPeriod: 'Extend Period',
  package: 'Package',
  productService: 'Product / Service',
  nextPaymentDate: 'Next Payment Date',
  delayed: 'Delayed',
  days: 'days',
  noResultsFound: 'No payments found matching the filter',
  tryDifferentFilter: 'Select a different company or clear the filter.',
  addFirstItem: 'Start by adding your first item.',
  more: 'more',
  selectDate: 'Select a date'
};
